"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AnnotationQuestionSolid: function() {
        return AnnotationQuestionSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const AnnotationQuestionSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5 2C3.34315 2 2 3.34315 2 5V17C2 18.6569 3.34315 20 5 20H8.2448L11.3356 22.7474C11.7145 23.0842 12.2855 23.0842 12.6644 22.7474L15.7552 20H19C20.6569 20 22 18.6569 22 17V5C22 3.34315 20.6569 2 19 2H5ZM10.2441 9.32561C10.4404 8.56264 11.1342 8 11.9569 8C12.9336 8 13.7254 8.79177 13.7254 9.76847C13.7254 10.1505 13.5862 10.4246 13.1792 10.8205C12.9793 11.015 12.7459 11.2087 12.4538 11.451L12.365 11.5248C12.043 11.7923 11.673 12.1037 11.2978 12.4742C10.9049 12.8623 10.9009 13.4955 11.289 13.8884C11.677 14.2814 12.3102 14.2854 12.7032 13.8973C13.0127 13.5915 13.3258 13.3267 13.6431 13.0631L13.7379 12.9845C14.0166 12.7535 14.3134 12.5074 14.5738 12.2541C15.1869 11.6577 15.7254 10.8994 15.7254 9.76847C15.7254 7.6872 14.0382 6 11.9569 6C10.1996 6 8.72548 7.20194 8.3072 8.8271C8.16953 9.36195 8.49152 9.90713 9.02637 10.0448C9.56123 10.1825 10.1064 9.86047 10.2441 9.32561ZM11.9705 16C11.4182 16 10.9705 16.4477 10.9705 17C10.9705 17.5523 11.4182 18 11.9705 18H11.9805C12.5327 18 12.9805 17.5523 12.9805 17C12.9805 16.4477 12.5327 16 11.9805 16H11.9705Z",
        fill: "currentColor"
    })
}), "AnnotationQuestionSolid");
const _default = AnnotationQuestionSolid;
